import { Children, cloneElement, isValidElement } from 'react';
import classNames from 'classnames';

import Typography from '@components/atoms/Typography';
import createStyleVariables from 'utils/createStyleVariables';

import CheckListItem from './components/CheckListItem';
import classes from './CheckList.module.scss';
import Props from './CheckList.types';

const CheckList = ({
  children,
  color = 'black',
  size = 'body1',
  variant = 'check',
  checkerSize = 'md',
  itemsPerRow,
  className,
  title,
  listStyle,
}: Props): JSX.Element => {
  const ListComponent = listStyle === 'ordered' ? 'ol' : 'ul';

  return (
    <>
      {title && (
        <Typography variant="body1" renderAs="div" className={classes.title}>
          {title}
        </Typography>
      )}
      <ListComponent
        style={createStyleVariables({ itemsPerRow })}
        className={classNames(className, classes.wrapper, classes[listStyle], {
          [classes.grid]: itemsPerRow,
          [classes.flex]: !itemsPerRow,
        })}
      >
        {Children.map(children, (child) => {
          if (isValidElement(child)) {
            return cloneElement(child, {
              color,
              size,
              variant,
              listStyle,
              checkerSize,
            });
          }

          return null;
        })}
      </ListComponent>
    </>
  );
};

CheckList.Item = CheckListItem;

export default CheckList;
